import React, { useState, useRef } from 'react';
import { useScrollFadeIn } from '../../utils/scrollFadeIn';

function Seasonal({ items = [] }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const sectionRef = useRef(null);

  useScrollFadeIn(sectionRef, '.seasonal-item', [items]);

  const openModal = (item) => {
    setSelectedImage(item);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  if (items.length === 0) {
    return null;
  }

  // レイアウトクラスを決定（アイテム数に応じて調整）
  const getGridClass = () => {
    const count = items.length;
    if (count === 1) return 'seasonal-grid-1';
    if (count === 2) return 'seasonal-grid-2';
    if (count === 3) return 'seasonal-grid-3';
    return 'seasonal-grid-auto';
  };

  return (
    <section id="seasonal" className="seasonal" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">旬</h2>
        
        <div className={`seasonal-grid ${getGridClass()}`}>
          {items.map((item, index) => (
            <div 
              key={item.id} 
              className="seasonal-item fade-in"
              style={{ transitionDelay: `${index * 0.07}s` }}
              onClick={() => openModal(item)}
            >
              <div className="seasonal-image-wrapper">
                <img 
                  src={item.image_url} 
                  alt={item.comment || '旬のおすすめ'}
                  loading="lazy"
                />
              </div>
              {item.comment && (
                <p className="seasonal-comment">{item.comment}</p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* 画像拡大モーダル */}
      {selectedImage && (
        <div className="seasonal-modal" onClick={closeModal}>
          <div className="seasonal-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="seasonal-modal-close" onClick={closeModal}>×</button>
            <img src={selectedImage.image_url} alt={selectedImage.comment || '旬のおすすめ'} />
            {selectedImage.comment && (
              <p className="seasonal-modal-comment">{selectedImage.comment}</p>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default Seasonal;

